// src/domains/revenue/pages/detail-page.jsx
import React, { useEffect, useState } from "react";
import { getJson } from "../../../utils/api";

export function RevenueDetailPage({ match }) {
  const id = match?.params?.id;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    async function run() {
      try {
        const res = await getJson(`/api/v3/revenues/${id}`);
        setData(res);
      } catch (e) {
        setError(e?.message || "Load failed");
      } finally {
        setLoading(false);
      }
    }
    run();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div style={{ color: "red" }}>{error}</div>;
  if (!data) return <div>No data</div>;

  return (
    <div className="container py-3">
      <h3>Revenue Detail</h3>
      <div style={{ display: "grid", gap: 8 }}>
        <div><strong>SKU:</strong> {data.sku}</div>
        <div><strong>Type:</strong> {data.kind}</div>
        <div><strong>Status:</strong> {data.status}</div>
        <div><strong>Counterparty:</strong> {data.counterparty_name}</div>
        <div><strong>Buying Price:</strong> {data.buying_price}</div>
        <div><strong>Assist By:</strong> {(data.assist_by || []).join(", ") || "—"}</div>
      </div>
    </div>
  );
}
